import { Link as MuiLink, Paper, Typography } from '@mui/material'
import { Link } from 'react-router-dom'

import { EChatbotTheme, TLink } from '~/features/settings/models'
import { store } from '~/store'

function Item({ url, label }: TLink) {
  const chatbotLayout = store((state) => state.chatbot.layout)
  return (
    <MuiLink
      component={Link}
      to={url}
      sx={{ textDecoration: 'none' }}
      target="_blank"
    >
      <Paper
        elevation={3}
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          maxWidth: 500,
          width: { xxxs: '100%', md: 500 },
          height: { xxxs: 32, md: 42 },
          borderRadius: 2,
          overflow: 'hidden',
          cursor: 'pointer',
          '&:hover': {
            transform: 'scale(1.05)',
          },
          transition: 'transform 0.3s ease-in-out',
          backgroundColor:
            chatbotLayout.options[EChatbotTheme.linkView][
              chatbotLayout.selection[EChatbotTheme.linkView]
            ].buttonColor,
        }}
      >
        <Typography
          variant="body1"
          sx={{
            textDecoration: 'none',
            color:
              chatbotLayout.options[EChatbotTheme.linkView][
                chatbotLayout.selection[EChatbotTheme.linkView]
              ].buttonTextColor,
          }}
        >
          {label}
        </Typography>
      </Paper>
    </MuiLink>
  )
}

export default Item
